export const QUIZ_ANSWER_STATES = {
  CORRECT: "correct",
  DISABLED: "disabled",
  INCORRECT: "incorrect",
  LOCKED: "locked",
  SKIPPED: "skipped",
  UNLOCKED: "unlocked"
};

export const QUIZ_RESULT_STATES = {
  CORRECT: "correct",
  INCORRECT: "incorrect",
  SKIPPED: "skipped"
};

export const REUSABLES = {
  SUBTOPIC: "subtopic",
  TITLE: "title",
  TOPIC: "topic"
};

export const ANSWER_OPTION_LETTERS = ["a", "b", "c", "d"];
